(function () {
  'use strict';

  function readData(id) {
    var element = document.getElementById('unified-bundle-set-data-' + id);
    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('[unified-bundle-set] Invalid configuration JSON.', error);
      return null;
    }
  }

  function normalize(value) {
    return value == null ? '' : String(value);
  }

  function fallbackVariant(data, value, selectedOptions) {
    var variants = data.variants || [];
    var optionIndex = Number(data.optionIndex);
    var normalizedValue = normalize(value);
    var selected = (selectedOptions || []).map(normalize);

    return (
      variants.find(function (variant) {
        if (!variant.options || normalize(variant.options[optionIndex]) !== normalizedValue) return false;

        return variant.options.every(function (option, index) {
          if (index === optionIndex || !selected[index]) return true;
          return normalize(option) === selected[index];
        });
      }) ||
      variants.find(function (variant) {
        return variant.options && normalize(variant.options[optionIndex]) === normalizedValue;
      }) ||
      null
    );
  }

  window.unifiedBundleSetFactory = function (id) {
    var data = readData(id) || {};

    return {
      selectedValue: data.defaultValue || '',
      selectedOptions: data.defaultOptions || [],
      inventoryLabels: data.inventoryLabels || {},

      getVariant: function (value) {
        if (window.ctrFlavorInventory && typeof window.ctrFlavorInventory.resolveVariantForOptionValue === 'function') {
          return window.ctrFlavorInventory.resolveVariantForOptionValue(
            data.variants || [],
            Number(data.optionIndex),
            value,
            this.selectedOptions
          );
        }

        return fallbackVariant(data, value, this.selectedOptions);
      },

      getState: function (value) {
        var variant = this.getVariant(value);
        if (!variant) {
          return { available: false, soldOut: true, lowStock: false, backInStock: false };
        }

        if (window.ctrFlavorInventory && typeof window.ctrFlavorInventory.getVariantState === 'function') {
          return window.ctrFlavorInventory.getVariantState(variant);
        }

        return {
          available: variant.available !== false && !variant.sold_out,
          soldOut: variant.sold_out === true || variant.available === false,
          lowStock: variant.low_stock === true,
          backInStock: variant.back_in_stock === true
        };
      },

      isAvailable: function (value) {
        return this.getState(value).available;
      },

      isSoldOut: function (value) {
        return this.getState(value).soldOut;
      },

      isLowStock: function (value) {
        var state = this.getState(value);
        return !state.soldOut && !state.backInStock && state.lowStock;
      },

      isBackInStock: function (value) {
        return this.getState(value).backInStock;
      },

      swatchColor: function (value) {
        return (data.swatchColors || {})[normalize(value).toLowerCase()] || 'transparent';
      },

      placeSelector: function (element, attempt) {
        if (!element) return;

        var bundleSet = element.closest('[data-unified-bundle-set]');
        var productCard = bundleSet && bundleSet.querySelector('.product-card--product-card-bundle');
        var target = productCard && productCard.querySelector('[data-style-id="card_product_card_container_mBJA77"]');

        if (target) {
          target.insertAdjacentElement('afterend', element);
          productCard.classList.add('unified-bundle-set__product-card--has-selector');
          return;
        }

        var retry = Number(attempt || 0);
        if (retry < 20) {
          var self = this;
          window.setTimeout(function () {
            self.placeSelector(element, retry + 1);
          }, 50);
        }
      },

      selectValue: function (value) {
        var variant = this.getVariant(value);
        if (!variant || !this.isAvailable(value)) return;

        this.selectedValue = value;
        this.selectedOptions = variant.options || this.selectedOptions;

        window.dispatchEvent(
          new CustomEvent('unified-bundle-set:variant-change', {
            detail: {
              bundleId: id,
              variantId: variant.id,
              optionIndex: Number(data.optionIndex),
              optionValue: value
            }
          })
        );
      },

      init: function () {
        var self = this;
        var initialState = self.getState(self.selectedValue);

        if (!initialState.available) {
          var firstAvailableValue = (data.optionValues || []).find(function (value) {
            return self.isAvailable(value);
          });
          if (firstAvailableValue) self.selectedValue = firstAvailableValue;
        }

        var initialVariant = self.getVariant(self.selectedValue);
        if (initialVariant) self.selectedOptions = initialVariant.options || self.selectedOptions;
      }
    };
  };
})();
